module.exports = __webpack_public_path__ + "img/go.c03baff9.png";